import templateStr from 'text!./bop-confirmation.html';

export default [function () {
    return {
        restrict: 'A',
        template: templateStr
    };
}];


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/gw-portals-bop-components-angular/locationsAndBuildings/directives/bop-confirmation-directive/BOPConfirmationDirective.js
// module id = 1808
// module chunks = 0